import { type User } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { type WhatsNewMarks } from "../endpoints";
import { queryKeys } from "../queryKeys";

/** Adds Release Note ids to the caller's seen and/or notified sets
 * ("What's new", ADR 0005). The server answers with the whole user. */
export function useMarkWhatsNew(): UseMutationResult<User, Error, WhatsNewMarks> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (marks) => client.markWhatsNew(marks),
    onSuccess: (user) => {
      qc.setQueryData(queryKeys.me(), user);
    },
  });
}
